import { Route, Routes } from "react-router";
import Settings from "./Settings";
import { useSelector } from "react-redux";

function SettingsRoutes() {
  const integrationType = useSelector(
    (state) => state.auth?.user?.integrationType
  );

  if (integrationType === 3 || integrationType === 4) {
    return (
      <Routes>
        <Route
          path=""
          element={
            <center>
              <h1>404 Not Found</h1>
            </center>
          }
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="" element={<Settings />} />
      <Route path=":setting" element={<Settings />} />
    </Routes>
  );
}

export default SettingsRoutes;
